<div>
    <mat-expansion-panel
            class="light-flex-card tv-mat-expansion-indicator-light-bg"
            #panel
            (opened)="onPanelOpened()"
            (closed)="onPanelClosed()"
    >
        <mat-expansion-panel-header>
            <mat-panel-title class="sub-title">
                CGRP Garanti
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="header-item-filters">
            <button
                    (click)="editCGRPOnModal()"
                    [disabled]="isCgrpOnBusy"
                    [ngClass]="{'fade-in-right': panelOpened, 'fade-out-left': !panelOpened}"
                    class="tv-round-icon-button-icon-small-light-blue"
            >
                <mat-icon>add</mat-icon>
            </button>

        </div>

        <div class="container" [attr.aria-busy]="isCgrpOnBusy">
            <div class="item" *ngFor="let card of contractOnCards" [attr.inert]="isCgrpOnBusy ? '' : null">
                <div class="item-content">
                    <div class="item-header">
                        <span class="title" [attr.title]="card.line.target?.name">{{ card.line.target?.name }}</span>
                        <span class="date-range">{{ card.line.startDate }} - {{ card.line.endDate }}</span>
                        <span class="ca">{{ card.line.value }} €</span>
                    </div>
                    <div class="item-actions">
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Modifier le CGRP garanti"
                                [disabled]="isCgrpOnBusy" (click)="editCGRPOnModal(card.line, 'edit')">
                            <mat-icon svgIcon="edit"></mat-icon>
                        </button>
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Dupliquer le CGRP garanti"
                                [disabled]="isCgrpOnBusy" (click)="dupCGRPOn(card.line)">
                            <mat-icon svgIcon="content-copy"></mat-icon>
                        </button>
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Supprimer le CGRP garanti"
                                [disabled]="isCgrpOnBusy" (click)="confirmDelete(card.line)">
                            <mat-icon class="material-icons-outlined delete-action-icon">delete</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="conditions-container">
                    <h4 class="conditions-title">Conditions{{ card.line.conditions[0]?.isInclude === 0 ? ' exclues' : '' }}</h4>
                    <div class="conditions-table-scroll tv-custom-always-visible-scroll-bar">
                        <table mat-table [dataSource]="card.line.conditions" class="tv-ns-mat-table tv-ns-large-mat-table conditions-table">
                            <ng-container matColumnDef="category">
                                <th mat-header-cell *matHeaderCellDef>Catégorie de négo ({{ card.categoryCount }})</th>
                                <td mat-cell *matCellDef="let row">
                                    <span class="condition-cell-text" [attr.title]="row.categoryType?.name">{{ row.categoryType?.name }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef>Nom ({{ card.line.conditions.length }})</th>
                                <td mat-cell *matCellDef="let row">
                                    <span class="condition-cell-text" [attr.title]="row.category?.name">{{ row.category?.name }}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="number">
                                <th mat-header-cell *matHeaderCellDef>Numéro</th>
                                <td mat-cell *matCellDef="let row">
                                    <span class="condition-cell-text" [attr.title]="row.category?.id">{{ row.category?.id }}</span>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="conditionColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: conditionColumns"></tr>
                            <tr class="conditions-empty-row" *matNoDataRow>
                                <td [attr.colspan]="conditionColumns.length">Aucune condition</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div *ngIf="isCgrpOnBusy" class="cgrp-list-loading-overlay" role="status" aria-label="Chargement des CGRP garantis">
                <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
            </div>
        </div>

    </mat-expansion-panel>
</div>
